<template>

  <div class="row">


    <b-col lg="6" md="12" sm="12" order="2" order-lg="0" class="s504-section">
      <div class="">
        <slot name="pr-1"/>
      </div>
    </b-col>

    <b-col lg="6" md="12" sm="12" class="s504-section">
      <div class="">
        <slot name="pl-1"/>
      </div>
    </b-col>


  </div>


</template>

<script>
export default {
  name: "S504",
};
</script>

<style scoped>
.s504-section{
  display: table;
  vertical-align: middle;
}
.s504-section > div{
  display: table-cell;
  vertical-align: middle;
}

</style>